// extracted by mini-css-extract-plugin
export default {"root":"IconInquiry_root__YOXkQ","marketplaceColorStroke":"IconInquiry_marketplaceColorStroke__fhVXd"};